var isMobile = function (scene) { return !scene.sys.game.device.os.desktop; };
var UtilsDevice = {
    isMobile: isMobile,
};
export default UtilsDevice;
